import { Component, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmationResult } from '@shared/_constants';

@Component({
  selector: 'app-new-study-notice',
  templateUrl: './new-study-notice.component.html',
})
@HostListener('scroll', ['$event'])
export class NewStudyNoticeComponent {
  isActive = true;

  constructor(private activeModal: NgbActiveModal) {}

  public async close() {
    this.activeModal.close(ConfirmationResult.no);
  }

  public async acknowledge() {
    this.activeModal.close(ConfirmationResult.yes);
  }

  scroll(element) {
    if (element != null) {
      element.scrollIntoView();
    }
  }
}
